import { createPermissionService } from './PermissionService.impl';
import store from '../../../../store';
import Account from 'lib/auth/Account';

export const myPermissionService = createPermissionService({
  store,
  getIsSuperUser: () => Account.isSuperUser()
});
